export default class CustomError extends Error {
  constructor({
    code,
    codeName,
    error,
    message,
    icon,
    title,
    technicalMessage,
    description,
    button,
    transactionId,
    endpoint
  }) {
    super(codeName);
    this.code = code || 1;
    this.codeName = codeName;
    this.title = error ? error.client.title['en-US'] : title;
    this.message = error ? error.client.message['en-US'] : message;
    this.description = error ? error.client.description['en-US'] : description;
    this.technicalMessage = error ? error.technicalMessage : technicalMessage;
    this.transactionId = transactionId;
    this.endpoint = endpoint || null;
    this.isCustomError = true;
    this.icon = icon || null;
    this.button = button || null;
  }
  serialize() {
    return {
      code: this.code,
      codeName: this.codeName,
      title: this.title,
      message: this.message,
      description: this.description,
      technicalMessage: this.technicalMessage,
      isCustomError: this.isCustomError,
      transactionId: this.transactionId,
      endpoint: this.endpoint,
      icon: this.icon,
      button: this.button
    };
  }
}
